var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.logsGroupByProcessId, function (logGroups, name, index) {
      return _c(
        "v-expansion-panel",
        {
          key: index,
          staticClass: "execution-logs mt-1",
          attrs: { color: "primary" },
        },
        [
          _c(
            "v-expansion-panel-content",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("v-flex", { attrs: { md6: "" } }, [
                          _c("strong", [_vm._v(" Process id:")]),
                          _vm._v("  " + _vm._s(name) + "\n        "),
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { md6: "" } }, [
                          _c("strong", [_vm._v(" Date:")]),
                          _vm._v(
                            "  " + _vm._s(_vm.getDate(logGroups)) + "\n        "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            },
            [
              _vm._v(" "),
              _c(
                "v-expansion-panel",
                { attrs: { expand: "", dark: "" } },
                _vm._l(logGroups, function (logs, i) {
                  return _c("LogContent", { key: i, attrs: { log: logs } })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }